
//   $('.open-right details').attr('open','');

if( $('.home-blog-list').is(':empty')) {
            console.log('empty');
  		$('.home-blog-list').append('<div class="none-block"></div> <div class="empty-blog-block"><p>No posts found</p></div> <div class="none-block"></div>');
}

if($('.home-blog-list .empty-blog-block')){
	$(this).parent('.home-blog-list').css('display','block');
}



$(()=>{
  /*let bool = false;
  console.log($('.success-message').length);
  function initForm(selector) {
	selector = selector || '.contact-form';

	document.querySelectorAll(selector).forEach(function(form) {
		let action = form.getAttribute("action");
		form.addEventListener('submit', function(e){
			e.preventDefault();
			fetch(action, {
				method: 'POST',
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json"
				},
	
			}).then(function(response) {
				$('.form-text-hide').css('display','none');
			}).catch(function(error) {
				
			});
		});
	});
}

initForm();*/

  let checkElement = $('.success-message').length;
  if( checkElement > 0){
    $('.form-text-hide').css('display','none');
  }else{
    $('.form-text-hide').css('display','block');
  }


  
});
